import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-topic-area-card',
  imports: [ReactiveFormsModule, TranslocoDirective, TranslocoPipe],
  templateUrl: './topic-area-card.component.html',
})
export class TopicAreaCardComponent {
  @Input() title = '';
  @Input() selected = false;
  @Input() preselected = false;
  @Input() disabled = false;
  @Input() trialing = false;
  @Output() cardClick: EventEmitter<void> = new EventEmitter<void>();

  onCardClick(): void {
    if (!this.preselected && !this.disabled) {
      this.cardClick.emit();
    }
  }

  getCardClasses(): string {
    if (this.preselected) {
      return 'border-gray bg-gray-100';
    }
    if (this.selected) {
      return 'bg-blue-veryLight ';
    }

    return 'border-gray-200 bg-white hover:border-gray-300';
  }

  getIconClasses(): string {
    if (this.preselected) {
      return 'bg-gray-200 text-gray-500';
    }
    if (this.selected) {
      return 'bg-grey-fadedGrey';
    }

    return 'text-gray-500';
  }
}
